import {
  FiGrid,
  FiShoppingBag,
  FiUsers,
  FiUser,
  FiCompass,
  FiGift,
  FiList,
  FiSettings,
} from "react-icons/fi";
import { BsBusFront, BsFillChatDotsFill, BsMap } from "react-icons/bs";
import language from "../../language";
import { BiTrip } from "react-icons/bi";
import { AiOutlineUser, AiOutlineTransaction } from "react-icons/ai";
import { FaFileInvoice } from "react-icons/fa";
import { MdRequestPage } from "react-icons/md";
/**
 * ⚠ These are used just to render the Sidebar!
 * You can include any link here, local or external.
 *
 * If you're looking to actual Router routes, go to
 * `routes/index.js`
 */
let languageSelectedEnglish =
  sessionStorage.getItem("language") === "english" ||
  !sessionStorage.getItem("language")
    ? true
    : false;

const sidebar = [
  {
    path: "/admin/dashboard", // the url
    icon: FiGrid, // icon
    name: `${languageSelectedEnglish ? "Dashboard" : language.dashboard}`,
  },
  {
    path: "/admin/buses",
    icon: BsBusFront,
    name: `${languageSelectedEnglish ? "Buses" : language.buses}`,
  },
  {
    path: "/admin/cities",
    icon: BsBusFront,
    name: `${languageSelectedEnglish ? "Cities" : language.buses}`,
  },
  {
    path: "/admin/bus-Stations",
    icon: BsMap,
    name: `${languageSelectedEnglish ? "Bus Stations" : language.requests}`,
  },
  {
    path: "/admin/trips",
    icon: BiTrip,
    name: `${languageSelectedEnglish ? "Trips" : language.trips}`,
  },
  {
    path: "/admin/packages",
    icon: BiTrip,
    name: `${languageSelectedEnglish ? "Packages" : language.packages}`,
  },
  {
    path: "/admin/customers",
    icon: AiOutlineUser,

    name: `${
      languageSelectedEnglish ? "Registered Travelers" : language.customers
    }`,
  },
  {
    path: "/admin/admins",
    icon: FiUsers,
    name: `${languageSelectedEnglish ? "Operators" : language.operators}`,
  },
  // {
  //   path: '/admin/AdminChat',
  //   icon: BsFillChatDotsFill,
  //   name: 'Chat',
  // },
  {
    path: "/admin/bookings",
    icon: FaFileInvoice,
    name: `${languageSelectedEnglish ? "Bookings" : language.bookings}`,
  },
  {
    path: "/admin/coupons",
    icon: FiGift,
    name: `${languageSelectedEnglish ? "Coupons" : language.coupons}`,
  },
  {
    path: "/admin/refundrequests",
    icon: MdRequestPage,
    name: `${languageSelectedEnglish ? "Refund Requests" : language.requests}`,
  },
  {
    path: "/admin/commissions",
    icon: MdRequestPage,
    name: `${languageSelectedEnglish ? "Commissions" : language.requests}`,
  },
  {
    path: "/admin/transactions",
    icon: AiOutlineTransaction,
    name: `${languageSelectedEnglish ? "Transactions" : language.requests}`,
  },
  // {
  //   path: "/admin/request",
  //   icon: MdRequestPage,
  //   name: `${languageSelectedEnglish ? "Requests" : language.requests}`,
  // },
  {
    path: "/admin/freetickets",
    icon: MdRequestPage,
    name: `${languageSelectedEnglish ? "Free Bookings" : language.requests}`,
  },

  {
    path: "/admin/profile",
    icon: FiSettings,
    name: `${languageSelectedEnglish ? "Edit Profile" : language.editProfile}`,
  },
];

export default sidebar;
